<dgx-modal
  class="guts-p-t-0"
  [canCancel]="true"
  [isHeaderBorderless]="false"
  [isPendingWithOverlay]="true"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
>
  <ng-container class="modal-header">
    {{ addResourceText }}
  </ng-container>

  <ng-container class="modal-body">
    <form role="form" class="form-wrap guts-p-full-1" (ngSubmit)="onSubmit()">
      <div class="">
        <label for="searchResources" class="guts-m-b-half font-strong ib">{{
          addFromCatalogText
        }}</label>
        <div class="l_flex rel">
          <input
            id="searchResources"
            autocomplete="off"
            name="searchResources"
            type="text"
            class="input"
            [placeholder]="searchForText"
            [attr.aria-label]="searchForText"
            [(ngModel)]="searchResourceInput"
            [ngbTypeahead]="getResources"
            (selectItem)="selectResource($event.item)"
            [resultTemplate]="searchItemTemplate"
            [inputFormatter]="searchItemFormatter"
            data-dgat="addBundleResourceModal-307"
          />
          @if (isSearching) {
            <da-spinner
              size="small"
              decorative
              class="tw-reset tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2"
            />
          }
        </div>
      </div>

      @if (!isSearching && noMatchingResults) {
        <div class="par--small guts-m-t-1">
          {{ noMatchText }}
        </div>
      }

      @if (selectedSearchResults.length) {
        <div class="guts-m-t-1">
          <h2 class="h4 guts-p-b-half border-bottom">
            {{ i18n.TargetResourcesForm_Selected }}
          </h2>
          <ul>
            @for (item of selectedSearchResults; track item) {
              <li data-dgat="addBundleResourceModal-bf1">
                <div class="l_flexbar border-bottom">
                  <div class="l_flex-grow">
                    <dgx-target-resource-list-item [item]="item" />
                  </div>
                  <div>
                    <button
                      type="button"
                      [ngbTooltip]="i18n.Core_Remove"
                      (click)="removeResource(item)"
                      data-dgat="addBundleResourceModal-630"
                    >
                      <da-icon
                        icon="x-mark"
                        class="tw-reset tw-inline-block tw-align-middle"
                        type="solid-small"
                      ></da-icon>
                    </button>
                  </div>
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </form>
  </ng-container>

  <ng-container class="modal-footer">
    <button
      type="button"
      class="tw-btn-busy tw-btn-primary tw-btn-medium"
      (click)="!isSubmitBlocked && onSubmit()"
      [class.is_disabled]="isSubmitBlocked"
      [attr.aria-disabled]="isSubmitBlocked ? 'true' : null"
      [attr.aria-busy]="isSaving ? 'true' : null"
      [attr.aria-label]="isSaving ? i18n.Core_Loading : addResourceText"
      data-dgat="add-bundle-resource-modal-ea8"
    >
      <da-spinner
        class="tw-reset"
        size="small"
        decorative
        [isActive]="isSaving"
      />
      <span class="tw-btn-busy__label">{{ addResourceText }}</span>
    </button>
  </ng-container>
</dgx-modal>

<!-- template for search results -->
<ng-template #searchItemTemplate let-item="result" let-term="term">
  <dgx-target-resource-list-item [item]="item" />
</ng-template>
